import styled from 'styled-components';

export const MusicPlayerRow = styled.div`
  position: relative;
  /* background-color: pink; */
  /* padding: 40px; */
  height: calc(100vh - ${props => props.theme.topNavBarHeight});
  border-bottom: 1px solid rgba(0,0,0,0.1);
`